import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type AuthCallbackGetLinkParams =
  /**
   * Authenticating a user
   * `/auth/callback`
   */
  {
    page: 'authCallback';
    redirectPath?: string;
  };

export const isAuthCallbackPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  return parts?.[1] === 'auth' && parts?.[2] === 'callback';
};
